$(document).ready(function () {
  $(".BrandCarousel").owlCarousel({
    loop: false,
    margin: 10,
    nav: true,
    dots: false,
    navText: ['<span class="left"></span>', '<span class="right"></span>'],
    responsive: {
      0: {
        items: 2,
        autoplay: true,
      },
      600: {
        items: 4,
        autoplay: true,
      },
      1000: {
        items: 7,
        autoplay: true,
      },
    },
  });
});
